import { render, staticRenderFns } from "./NphPersonalHistory.vue?vue&type=template&id=adb72c16"
import script from "./NphPersonalHistory.vue?vue&type=script&lang=js"
export * from "./NphPersonalHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports